import { FC } from "react";

import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import { Button, Card, useTheme } from "@mui/material";
import { tokens } from "@/components/Application/theme";

interface ErrorProps {
	message?: string;
	reset: () => void;
}

const ComponentError: FC<ErrorProps> = ({ message, reset }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
	return (
		<Card
			style={{
				color: colors.redAccent[400],
				padding: ".5rem",
				backgroundColor: colors.redAccent[900],
				borderColor: colors.redAccent[400],
				borderRadius: "5px",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				margin: "auto",
                gap: "1rem",
			}}
		>

				<CrisisAlertIcon sx={{ color: colors.redAccent[400] }} />
				<strong>An error occurred</strong>

			<Button
				variant="outlined"
				color="error"
				onClick={reset}
			>Try again</Button>
		</Card>
	);
};

export default ComponentError;